export default __webpack_public_path__ + "static/media/3.17514084.png";